import {
  constants,
  typographyStyles,
  mediaQueryStyles,
} from "@newsela/angelou";
const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { xs },
} = constants.breakpoints;

const { textMObj, textXSObj } = typographyStyles;
const { ui } = constants.colors;

export const topicRowCss = (small) => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  justifyContent: "flex-start",
  gap: small && "24px",
});

export const topicBlockCss = (hasBorderBetween, small) => {
  return {
    display: "flex",
    flexDirection: "row",
    alignItems: small ? "center" : "flex-end",
    fontFamily: "Circular",
    color: ui.neutral[600],
    paddingRight: hasBorderBetween ? "16px" : "0px",
    paddingLeft: hasBorderBetween ? "16px" : "0px",
    borderRight: hasBorderBetween ? `solid ${ui.neutral[600] + "1f"}` : "none",
    "&:last-child": {
      borderRight: "none",
    },

    [mq.downTo(xs)]: {
      paddingRight: hasBorderBetween ? "32px" : "0px",
      paddingLeft: hasBorderBetween ? "32px" : "0px",
    },
    "&:first-child": !small && {
      paddingLeft: hasBorderBetween ? "0" : "32px",
    },
  };
};

export const topicAmountCss = (isHomeVersion, small) => ({
  ...(!isHomeVersion && { marginRight: "10px" }),
  fontSize: small ? "14px" : !isHomeVersion ? "32px" : "14px",
  lineHeight: "1",
  display: "flex",
  fontWeight: 700,
  fontFamily: "inherit",
  [mq.downTo(xs)]: {
    fontSize: small ? "20px" : !isHomeVersion ? "32px" : "14px",
  },
});

export const topicLabelCss = (isHomeVersion, small) => ({
  ...textXSObj,
  ...(isHomeVersion && { textTransform: "uppercase" }),
  ...(small && { textTransform: "capitalize" }),

  [mq.downTo(xs)]: {
    ...textMObj,
  },
});

export const tokenCss = {
  width: 24,
  height: 24,
  marginRight: 7,
};
